import { RouterSuspense } from '@/common/components/RouterSuspense/RouterSuspense';
import { MARKET } from '@/common/constants/markets';
import { ROUTES } from '@/common/constants/routes';
import { ESHomePage } from '@/common/containers/Dashboard/Home/ESHomePage/ESHomePage';
import { ITHomePage } from '@/common/containers/Dashboard/Home/ITHomePage/ITHomePage';
import { PTHomePage } from '@/common/containers/Dashboard/Home/PTHomePage/PTHomePage';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { ICompany } from '@/common/types/company';
import { safeLazy } from '@/common/utils/import';
import { ErrorPage } from '@/web/components/ErrorPage/ErrorPage';
import { LoadingPlaceholder } from '@/web/components/LoadingPlaceholder/LoadingPlaceholder';
import { useHomeRedirect } from '@/web/hooks/useHomeRedirect';
import { Href, Redirect } from 'expo-router';

const { ITDashboardHome } = safeLazy(
  () => import('@/web/containers/Dashboard/ITDashboard/ITDashboard')
);

export default function DashboardHomePage() {
  const { company } = useEmployeeDetails();
  const { route, loadingRoute } = useHomeRedirect();
  const dashboardComponent = useDashboardComponent(company);

  if (loadingRoute) {
    return <LoadingPlaceholder />;
  }

  if (route) {
    return <Redirect href={route as Href} />;
  }

  return <RouterSuspense>{dashboardComponent}</RouterSuspense>;
}

const useDashboardComponent = (company: ICompany) => {
  const {
    features: { ff_single_meal_transaction },
  } = useFeatures();

  switch (company.market.slug) {
    case MARKET.PT: {
      return <PTHomePage />;
    }
    case MARKET.IT:
      return ff_single_meal_transaction ? <ITHomePage /> : <ITDashboardHome />;
    case MARKET.ES:
      return <ESHomePage />;
    default:
      return <Redirect href={ROUTES.NOT_FOUND} />;
  }
};

export function DashboardHomeErrorBoundary() {
  return <ErrorPage embedded />;
}
